import React from "react";
import { Grid, Row, Col } from "react-flexbox-grid";
import { Label, DefaultButton } from "office-ui-fabric-react";
import Common from "./Common";
import axios from "axios";
class Confirmacion extends React.Component {
  state = {
    orden: "",
    mensaje: "",
    tarjeta: "",
    tipotarjeta: "",
    fecha: "",
    importe: "",
    moneda: "",
    descripcionPago: "",
    jwt: "",
    codigoTop: ""
  };
  async componentDidMount() {
    let authPayment = {
      headers: {
        Authorization: "Bearer " + this.props.jwt
      }
    };
    const resPaymentGet = await axios
      .get(`${Common.urlAPI}/getPay/${this.props.orden}`, authPayment)
      .catch(error => {
        if (error.response.status === 401) {
          alert("El token es invalido para este usuario");
        }
      });
    this.setState({
      orden: this.props.orden,
      mensaje: this.props.mensaje.replace("'", "").replace("'", ""),
      tarjeta:
        this.props.tarjeta === ""
          ? resPaymentGet.data.detail.tarjeta
          : this.props.tarjeta,
      tipotarjeta:
        this.props.tipotarjeta === ""
          ? resPaymentGet.data.detail.tipotarjeta.toUpperCase()
          : this.props.tipotarjeta.toUpperCase(),
      fecha:
        this.props.fecha.substring(0, 2) +
        "/" +
        this.props.fecha.substring(2, 4) +
        "/" +
        this.props.fecha.substring(4, 6) +
        " " +
        this.props.fecha.substring(6, 8) +
        ":" +
        this.props.fecha.substring(8, 10) +
        ":" +
        this.props.fecha.substring(10, 12),
      importe: parseFloat(resPaymentGet.data.detail.monto).toFixed(2),
      moneda: "Soles",
      descripcionPago: resPaymentGet.data.detail.tipooperacion,
      jwt: this.props.jwt,
      codigoTop: resPaymentGet.data.detail.codigotop,
      idcertifikate: resPaymentGet.data.detail.idcertifikate
    });
  }
  handleImprimir = () => {
    window.print();
  };
  handleContinuar = () => {
    if (this.state.codigoTop === "CE") {
      window.location = `${Common.CERTIFIKATE_URL}/pagos/datos/${this.state.idcertifikate}`;
    } else if (
      this.state.codigoTop === "ES" ||
      this.state.codigoTop === "RC" ||
      this.state.codigoTop === "RS" ||
      this.state.codigoTop === "PP" ||
      this.state.codigoTop === "PM" ||
      this.state.codigoTop === "RX" ||
      this.state.codigoTop === "TC"
    ) {
      if (this.state.codigoTop === "PM" || this.state.codigoTop === "PP") {
        window.location = `${Common.URLMooestroPortalAlumnos}/finance?mId=finance&eId=economicDetails`;
      } else if (this.state.codigoTop === "TC") {
        window.location = `${Common.URLMooestroPortalAlumnos}/requests-data/2`;
      } else if (
        this.state.codigoTop === "RC" ||
        this.state.codigoTop === "RX"
      ) {
        window.location = `${Common.URLMooestroPortalAlumnos}/requests-data/4`;
      } else if (this.state.codigoTop === "ES") {
        window.location = `${Common.URLMooestroPortalAlumnos}/requests-data/5`;
      } else {
        window.location = `${Common.URLMooestroPortalAlumnos}/requests-data/1`;
      }
    } else {
      window.location = `${Common.PORTAL_TRAMITES_UPN_URL}`;
    }
  };
  render() {
    return (
      <React.Fragment>
        {this.state.loading ? <div className="preloader"></div> : null}
        <Grid style={{ padding: "2rem 5rem" }}>
          <Row middle="xs" className="card">
            <Col xs={12} sm={12} className="container">
              <Row style={{ justifyContent: "Center" }}>
                <Col xs={12} sm={3} style={{ display:"flex", justifyContent: "Center", maxHeight: "160px" }}>
                  <img                
                    src="https://upn-repositorio-public.s3.amazonaws.com/logos/png/logo-upn-sin-fondo.png"
                    style={{objectFit: "cover", width:"50vw", height:"100%"}}
                    alt="logo"
                  ></img>
                </Col>
              </Row>

              <Row center="xs">
                <Col xs={12} sm={12}>
                  <Label
                    style={{
                      fontWeight: "bold",
                      color: this.state.mensaje !== "" ? "red" : "green"
                    }}
                  >
                    {this.state.mensaje === ""
                      ? "Su pago se ha realizado con éxito"
                      : "Lo sentimos, el pago ha sido denegado."}
                  </Label>
                </Col>
              </Row>
              <Row center="xs">
                <Col xs={12} sm={3}>
                  <Label style={{ fontWeight: "bold" }}>
                    Nro. pedido: {this.state.orden}
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={12}>
                  <Row center="xs">
                    <Col xs={12} sm={6}>
                      <h3 className="current">Información del pago</h3>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row center="xs">
                <Col xs={12} sm={3}>
                  <Label style={{ fontWeight: "bold" }}>Marca de tarjeta</Label>
                </Col>
                <Col xs={12} sm={3}>
                  <Label>{this.state.tipotarjeta}</Label>
                </Col>
              </Row>
              <Row center="xs">
                <Col xs={12} sm={3}>
                  <Label style={{ fontWeight: "bold" }}>
                    Número de tarjeta
                  </Label>
                </Col>
                <Col xs={12} sm={3}>
                  <Label>{this.state.tarjeta}</Label>
                </Col>
              </Row>
              <Row center="xs">
                <Col xs={12} sm={3}>
                  <Label style={{ fontWeight: "bold" }}>
                    Fecha y Hora de pedido
                  </Label>
                </Col>
                <Col xs={12} sm={3}>
                  <Label>{this.state.fecha}</Label>
                </Col>
              </Row>
              <Row center="xs">
                <Col xs={12} sm={3}>
                  <Label style={{ fontWeight: "bold" }}>Importe</Label>
                </Col>
                <Col xs={12} sm={3}>
                  <Label>{this.state.importe}</Label>
                </Col>
              </Row>
              <Row center="xs">
                <Col xs={12} sm={3}>
                  <Label style={{ fontWeight: "bold" }}>Moneda</Label>
                </Col>
                <Col xs={12} sm={3}>
                  <Label>{this.state.moneda}</Label>
                </Col>
              </Row>
              <Row center="xs">
                <Col xs={12} sm={3}>
                  <Label style={{ fontWeight: "bold" }}>Descripción</Label>
                </Col>
                <Col xs={12} sm={3}>
                  <Label>{this.state.descripcionPago}</Label>
                </Col>
              </Row>
              {this.state.mensaje !== "" ? (
                <Row center="xs">
                  <Col xs={12} sm={3}>
                    <Label style={{ fontWeight: "bold" }}>Motivo</Label>
                  </Col>
                  <Col xs={12} sm={3}>
                    <Label style={{ color: "red" }}>{this.state.mensaje}</Label>
                  </Col>
                </Row>
              ) : null}
              <br></br>
              <Row center="xs">
                <Col xs={12} sm={12}>
                  <span
                    style={{
                      fontStyle: "italic",
                      fontSize: "0.5rem !important"
                    }}
                  >
                    * Se recomienda capturar o imprimir esta pantalla
                  </span>
                </Col>
              </Row>
              <br></br>
              <Row center="xs">
                <Col xs={12} sm={3}>
                  <DefaultButton
                    className="btn-primary"
                    text="Continuar"
                    onClick={this.handleContinuar}
                  ></DefaultButton>
                </Col>
                &nbsp; &nbsp;
                <Col xs={12} sm={3}>
                  <DefaultButton
                    className="btn-primary"
                    text="Imprimir"
                    onClick={this.handleImprimir}
                  ></DefaultButton>
                </Col>
              </Row>
              <br></br>
              <hr></hr>
              <br></br>
              <Row center="xs">
                <Col xs={12} sm={12}>
                  Universidad Privada del Norte - 2020
                </Col>
              </Row>
              <br></br>
            </Col>
          </Row>
        </Grid>
      </React.Fragment>
    );
  }
}
export default Confirmacion;
